<div class="input-group">
  <input
    ngbDatepicker
    #d="ngbDatepicker"
    class="form-control"
    [class.is-invalid]="isInvalid"
    name="dp"
    [attr.id]="id"
    [(ngModel)]="ngbDate"
    (click)="d.toggle()"
    [disabled]="disabled"
    [minDate]="ngbMinDate"
    [maxDate]="ngbMaxDate"
    [markDisabled]="isDisabled"
    [firstDayOfWeek]="7"
    [dayTemplate]="dayTemplate"
    [footerTemplate]="footerTemplate"
    readonly
    (keydown.enter)="d.toggle()"
    (dateSelect)="onDateChange($event)"
    style="max-width: 208px; cursor: pointer"
    title="click to select a date"
  />
  <button
    type="button"
    class="btn btn-outline-secondary d-flex align-items-center"
    (click)="d.toggle()"
    [disabled]="disabled"
  >
    <svg
      aria-hidden="true"
      role="icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 448 512"
    >
      <path
        fill="currentColor"
        d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
      ></path>
    </svg>
  </button>
</div>

<ng-template
  #dayTemplate
  let-date="date"
  let-disabled="disabled"
  let-currentMonth="currentMonth"
>
  <span
    class="custom-day"
    [class.weekend]="isWeekend(date)"
    [class.disabled]="disabled"
    [class.outside]="date.month !== currentMonth"
  >
    {{ date.day }}
  </span>
</ng-template>

<ng-template #footerTemplate>
  <div *ngIf="allowClear">
    <hr class="my-0" />
    <button
      class="btn btn-primary btn-sm m-2 float-start"
      (click)="ngbDate = today; onDateChange(today); d.close()"
    >
      Today
    </button>
    <button
      class="btn btn-secondary btn-sm m-2 float-end"
      (click)="ngbDate = null; dateChange.emit(undefined); d.close()"
    >
      Clear
    </button>
  </div>
</ng-template>
